"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeeKind = void 0;
var FeeKind;
(function (FeeKind) {
    FeeKind["Fixed"] = "fixed";
    FeeKind["Percent"] = "percent";
})(FeeKind = exports.FeeKind || (exports.FeeKind = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmVlS2luZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9mZWVzL0ZlZUtpbmQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxPQUdYO0FBSEQsV0FBWSxPQUFPO0lBQ2pCLDBCQUFlLENBQUE7SUFDZiw4QkFBbUIsQ0FBQTtBQUNyQixDQUFDLEVBSFcsT0FBTyxHQUFQLGVBQU8sS0FBUCxlQUFPLFFBR2xCIn0=